module.exports = __webpack_public_path__ + "static/media/3040166000_01.c4ea9e59.jpg";